import React, { Component } from "react";
// import "../initialPage/initial.scss";
import { Col, Row } from 'bootstrap-4-react';

class HeaderPointSalePage extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    
  }

  componentDidMount() {  }

  render() {
    const { typeHeader, renderView, signedIn, } = this.props.initState

    return (
      <div style={{ height: (typeHeader === 0 ? '60px' : '60px'), overflow: 'hidden', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1, }} >
        {/* HEADER */}
        <div style={{ background: '#DA3A2F', height: 58, }}>
          <Row>
            <Col xs={4} md={4}>
              <p className="initialPage__headerText" style={{ lineHeight: 'inherit', textAlign: 'left', paddingLeft: 10, width: '55%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', }}>{signedIn.nombre} {signedIn.apellidos}</p>
              {
                signedIn.type === 2 ? (
                  <p className="initialPage__headerText" style={{ lineHeight: '13px', textAlign: 'left', paddingLeft: '10px', fontSize: '14px', fontWeight: 'bold', }}>Sucursal {signedIn.sucursal}</p>
                ) : null
              }
              {
                signedIn.type === 5 ? (
                  <p className="initialPage__headerText" style={{ lineHeight: '13px', textAlign: 'left', paddingLeft: '10px', fontSize: '14px', fontWeight: 'bold', }}>PUNTO DE VENTA</p>
                ) : null
              }
              <p
                onClick={() => {
                  localStorage.removeItem('hg_app_s');
                  window.location.reload()
                }}
                className="initialPage__headerText" style={{ lineHeight: '13px', textAlign: 'left', paddingLeft: '10px', fontSize: '.8rem', fontWeight: 'bold', cursor: 'pointer', }}>Cerrar sesión</p>
            </Col>
            {
              signedIn.type === 5
              ? <Col xs={2} style={{ textAlign: 'center', }}></Col>
              : <Col style={{ textAlign: 'center', }}></Col>
            }
            <Col style={{ textAlign: 'right', paddingTop: 5, position: 'relative', right: 10, cursor: 'pointer' }}>

              <Row style={{ background: 'transparent', borderRadius: '4px', padding: '3px', width: '100%', marginTop: 5, }}>
                {
                  signedIn.type === 2 ? (
                    <Col>
                      <p
                        onClick={ () => { this.props.initsetState({ renderView: 'nuevaCompra', }) }}
                        className={`ws-btn-switch ${renderView === 'nuevaCompra' ? 'switch-active' : ''}`}>VENTAS</p>
                    </Col>
                  ) : null
                }
                {
                  signedIn.type === 5 ? (
                    <Col>
                      <p
                        onClick={ () => { this.props.initsetState({ renderView: 'nuevaCompraRuta', }) }}
                        className={`ws-btn-switch ${renderView === 'nuevaCompraRuta' ? 'switch-active' : ''}`}>RUTA SUR</p>
                    </Col>
                  ) : null
                }
                <Col>
                  <p
                    onClick={ () => { this.props.initsetState({ renderView: 'general', }, this.goToGeneral) }}
                    className={`ws-btn-switch ${renderView === 'general' ? 'switch-active' : ''}`}>RESUMEN</p>
                </Col>
                {
                  signedIn.type === 5 ? (
                    <Col>
                      <p
                        onClick={ () => { this.props.initsetState({ renderView: 'altas_ruta', }, this.goToGeneral) }}
                        className={`ws-btn-switch ${renderView === 'altas_ruta' ? 'switch-active' : ''}`}>PEDIDOS SUGERIDOS</p>
                    </Col>
                  ) : null
                }
                <Col>
                  <p
                    onClick={ () => { this.props.initsetState({ renderView: 'altas', }, this.goToGeneral) }}
                    className={`ws-btn-switch ${renderView === 'altas' ? 'switch-active' : ''}`}>ALTAS</p>
                </Col>
                <Col>
                  <p
                    onClick={ () => { this.props.initsetState({ renderView: 'actualiza-costos', }, this.goToGeneral) }}
                    className={`ws-btn-switch ${renderView === 'actualiza-costos' ? 'switch-active' : ''}`}>COSTOS</p>
                </Col>
              </Row>
              
            </Col>
          </Row>
        </div>

        {/* SUBHEADER */}


        { this.makeSubheaderByToken() }
      </div>
    );
  }

  makeSubheaderByToken() {
    const { viewApp, tabProgresoActive } = this.props.initState

    if(viewApp === 'admin') {
      return (
        <div className="initialPage__subheader">
          <Row className="initialPage__subheaderTabs">
            <Col onClick={ () => { this.props.initsetState({ tabProgresoActive: 1 }) } }>
              <p>Venta</p>
              { tabProgresoActive === 1 ? ( <div className="initialPage__tabActive"></div> ) : null }
            </Col>
            <Col onClick={ () => { this.props.initsetState({ tabProgresoActive: 2 }) } }>
              <p>Gastos</p>
              { tabProgresoActive === 2 ? ( <div className="initialPage__tabActive"></div> ) : null }
            </Col>
            <Col onClick={ () => { this.props.initsetState({ tabProgresoActive: 3 }) } }>
              <p>Almacén</p>
              { tabProgresoActive === 3 ? ( <div className="initialPage__tabActive"></div> ) : null }
            </Col>
            <Col onClick={ () => { this.props.initsetState({ tabProgresoActive: 4 }) } }>
              <p>Utilidad</p>
              { tabProgresoActive === 4 ? ( <div className="initialPage__tabActive"></div> ) : null }
            </Col>
          </Row>
        </div>
      )
    } else if(viewApp === 'user') {
      return null
    }
  }

};

export default HeaderPointSalePage